import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver, extend as veeExtend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import '@fortawesome/fontawesome-free/css/all.css';
import 'animate.css';

import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';
import jquery from 'jquery';
import App from './App.vue';
import router from './router';
import store from './store';

// 引入元件
import '@/plugins/components'

import { messages } from './configs/vee-validate-message.json';
import './assets/sass/styles.scss';

// 日期format
// import 'moment/locale/zh-cn'

// 引入filter (默認檔案是index.js)
import * as filters from './filters';


// 解決 Router 報錯誤題
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// matomo
// const nowUrl = window.location.href.split("/T")[0]
// const judgeSiteId = nowUrl === 'https://test-receipts.gov.taipei' ? 3:1
// const matomoHost =  nowUrl === 'https://e-receipts.gov.taipei' ? 'https://e-receipts.gov.taipei/matomo/' : 'http://172.104.78.70/'
// import VueMatomo from 'vue-matomo'
// Vue.use(VueMatomo, {
// host:  matomoHost,
// siteId: judgeSiteId,//siteId值
// // 根據router自動註冊
// router: router,
// // // 是否需要在發送追蹤信息之前請求許可
// // // 默認false
// requireConsent: false,
// enableLinkTracking: false,
// // // 是否追蹤初始頁面
// // // 默認true
// trackInitialView: true,
// // // 最終的追蹤js文件名
// trackerFileName: 'matomo',
// debug: true
// });

Vue.config.productionTip = false;
window.$ = jquery; // 讓瀏覽器的全域環境可以使用到 $

Vue.use(VueAxios, axios);
Vue.prototype.$moment = moment; // 赋值使用
/* Register Plugins */
Vue.use(BootstrapVue);

/* Register components */
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// 下拉選單驗證，是否為有效值
veeExtend('isInvalid', (value, id) => {
  if(id[0] !== 'null'){
    return true;
  };
  return `{_field_} 請選有效值`;
});

// 檢核不可多個零
veeExtend('noMoreZero', (value, id) => {
  console.log('value.length-', value.length);
  let re =/0{8,9}$/;
    if(!re.test(value)){
      return true;
    };
  return `{_field_} 為無效值`;
});

// 檢核長度至少n
veeExtend('minLength', (value, n) => {
    if(value.length == n[0]) {
      return true;
    };
  return `{_field_} 字數需為${n}個字`;
});

/* Register VeeValidate rules */
Object.keys(rules).forEach((rule) => {
  veeExtend(rule, {
    ...rules[rule],
    message: messages[rule],
  });
});

// 將所有引入filter 方法 註冊全域filter
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
